(() => {
  if (window.voltaireEditorialScroll) return;
  window.voltaireEditorialScroll = true;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  if (!('IntersectionObserver' in window)) return;
  const selector = '[data-reveal], .v-serpent-story__copy > *, .v-wrist-feature__copy > *, .v-story__body > p, [data-reveal-paragraphs] > p, .v-product-card';
  const reveal = el => {el.classList.remove('is-waiting');observer.unobserve(el);};
  const observer = new IntersectionObserver(entries => entries.forEach(entry => {
    if (entry.isIntersecting) reveal(entry.target);
  }), {threshold: 0.08});
  const init = (root = document) => {
    // Give each approved story line its own gentle entrance; preserve inline formatting.
    root.querySelectorAll('[data-story-lines] p').forEach(p => {
      if (p.dataset.linesReady) return;
      p.dataset.linesReady = 'true';
      const fragment = document.createDocumentFragment();
      let line = document.createElement('span');line.dataset.reveal = '';
      [...p.childNodes].forEach(node => {
        if (node.nodeName === 'BR') {fragment.append(line);line=document.createElement('span');line.dataset.reveal='';}
        else line.append(node);
      });
      fragment.append(line);p.replaceChildren(fragment);
    });
    root.querySelectorAll(selector).forEach(el => {
      if (el.dataset.revealReady || el.closest('details:not([open])')) return;
      el.dataset.revealReady = 'true';
      if (reduce.matches) return;
      el.classList.add('v-reveal');
      const index = [...el.parentElement.children].indexOf(el);
      el.style.setProperty('--reveal-delay', `${Math.min(index, 3) * 100}ms`);
      const rect=el.getBoundingClientRect();
      if (rect.top >= innerHeight * .9) {el.classList.add('is-waiting');observer.observe(el);}
    });
  };
  document.addEventListener('toggle', event => {
    if (event.target.matches('[data-story-disclosure]') && event.target.open) init(event.target);
  }, true);
  init();
  document.addEventListener('shopify:section:load', e => init(e.target));
  document.addEventListener('shopify:section:unload', e => e.target.querySelectorAll('.is-waiting').forEach(el => observer.unobserve(el)));
  document.addEventListener('shopify:section:select', e => e.target.querySelectorAll('.is-waiting').forEach(reveal));
  reduce.addEventListener('change', () => {
    if (reduce.matches) document.querySelectorAll('.is-waiting').forEach(reveal);
  });
  document.addEventListener('focusin', e => {const el=e.target.closest('.is-waiting');if(el)reveal(el);});
  window.addEventListener('beforeprint', () => document.querySelectorAll('.is-waiting').forEach(reveal));
})();
